/**
 * Minimal footer for pre-login routes only.
 * Used by PublicLayout, Landing, MarketingLayout, StaticPageLayout.
 * Do NOT use in /app (AppLayout has no footer).
 */

import { Link } from "react-router-dom";
import { useCookieConsent } from "@/contexts/CookieConsentContext";

const publicFooterLinks = [
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
  { to: "/cookies", label: "Cookies" },
  { to: "/support", label: "Support" },
] as const;

interface PublicFooterProps {
  className?: string;
}

export function PublicFooter({ className = "" }: PublicFooterProps) {
  const { openPreferences } = useCookieConsent();

  return (
    <footer
      className={`border-t border-border/40 bg-secondary/20 py-6 px-4 ${className}`.trim()}
      role="contentinfo"
    >
      <div className="container mx-auto max-w-[var(--landing-max-width,1280px)]">
        <nav
          className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground"
          aria-label="Footer navigation"
        >
          {publicFooterLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="hover:text-foreground transition-colors"
            >
              {label}
            </Link>
          ))}
          <button
            type="button"
            onClick={openPreferences}
            className="hover:text-foreground transition-colors text-left"
            aria-label="Open cookie preferences"
          >
            Cookie preferences
          </button>
        </nav>
        <p className="text-center text-sm text-muted-foreground mt-4">
          © {new Date().getFullYear()} Decision Sales OS
        </p>
      </div>
    </footer>
  );
}
